'use client'

import { BrandLogo } from '@/components/brand/BrandLogo'
import { AutoplayVideo } from '@/components/pages/site/home/sections/AutoplayVideo'
import Image from 'next/image'

const AUTH_HERO_VIDEO_SRC = '/videos/auth/auth-hero.mp4'
// First frame of the video: paints before the video loads (no visible swap) and is all that
// reduced-motion visitors see.
const AUTH_HERO_POSTER_SRC = '/images/auth/auth-hero-poster.webp'
// The panel is portrait but the clip is 16:9, so only ~44% of its width shows; the subject sits
// right of center in the subway shot.
const AUTH_HERO_CROP = 'object-cover object-[55%_center]'

export function AuthBrandingPanel() {
  return (
    <div className="relative size-full overflow-hidden rounded-3xl bg-zinc-900 lg:rounded-l-[1.75rem]">
      <Image
        src={AUTH_HERO_POSTER_SRC}
        alt=""
        fill
        priority
        sizes="50vw"
        className={AUTH_HERO_CROP}
      />
      <AutoplayVideo
        src={AUTH_HERO_VIDEO_SRC}
        className={`absolute inset-0 size-full motion-reduce:hidden ${AUTH_HERO_CROP}`}
      />
      <div
        className="absolute inset-x-0 top-0 z-10 bg-gradient-to-b from-zinc-950/60 via-zinc-950/25 to-transparent px-8 pb-14 pt-8 sm:px-10"
      >
        <BrandLogo
          size="md"
          href="/"
          showWordmark
          wordmarkClassName="text-white"
        />
      </div>
    </div>
  )
}
